import { CustomerPrivatePensionContractedNormalized } from '../../../../../../store/customerDetail/privatePension/types';

export interface ItemDataInfo {
  label: string;
  value: string;
}

const privatePensionFields = [
  { key: 'certificate', label: 'Certificado' },
  { key: 'insurer', label: 'Seguradora' },
  { key: 'fund', label: 'Fundo' },
  { key: 'positionDate', label: 'Data posição' },
  { key: 'planType', label: 'Tipo Plano' },
  { key: 'taxRegime', label: 'Rg. Tributário' },
  { key: 'dayPercentage', label: 'Dia(%)' },
  { key: 'monthPercentage', label: 'Mês(%)' },
  { key: 'yearPercentage', label: 'Ano(%)' },
  { key: 'currentQuota', label: 'Cota atual' },
  { key: 'grossValue', label: 'Valor bruto' },
  { key: 'certificateStatus', label: 'Status certificado' },
];

const privatePensionResumedFields = [
  { key: 'certificate', label: 'Certificado' },
  { key: 'insurer', label: 'Seguradora' },
  { key: 'fund', label: 'Fundo' },
  { key: 'planType', label: 'Plano' },
  { key: 'taxRegime', label: 'RG Tributário' },
  { key: 'certificateStatus', label: 'Situação' },
];

export const infos: ItemDataInfo[] = [
  { label: 'Certificado', value: '3341962' },
  { label: 'Seguradora', value: 'ICATU SEGUROS S/A' },
  { label: 'Fundo', value: 'Verde AM Icatu Prev FIM' },
  { label: 'Plano', value: 'PGBL' },
  { label: 'Rg. Tributário', value: '1,81' },
  { label: 'Situação certificado', value: 'ATIVO' },
];

export const getPrivatePensionCardInfos = (
  privatePension: CustomerPrivatePensionContractedNormalized
): ItemDataInfo[] =>
  privatePensionFields.map(({ key, label }) => ({
    label,
    value: privatePension[key as keyof CustomerPrivatePensionContractedNormalized],
  }));

export const getPrivatePensionCardResumedInfos = (
  privatePension: CustomerPrivatePensionContractedNormalized
): ItemDataInfo[] =>
  privatePensionResumedFields.map(({ key, label }) => ({
    label,
    value: privatePension[key as keyof CustomerPrivatePensionContractedNormalized],
  }));

export const getPrivatePensionCardLabels = (): ItemDataInfo[] =>
  privatePensionFields.map(({ label }) => ({ label, value: '' }));
